<template>
  <div class="prizes-2021-section">
    <Prizes2021SectionPlace v-if="place" :place="place" />
    <slot />
  </div>
</template>

<script>
import Prizes2021SectionPlace from "./Prizes2021SectionPlace";

export default {
  name: "Prizes2021Section",
  components: {
    Prizes2021SectionPlace
  },
  props: {
    place: {
      type: [Number, String],
      required: false
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-section {
  margin-bottom: 90px;

  @include breakpoint("sm-and-down") {
    margin-bottom: 75px;
  }

  @include breakpoint("xs-only") {
    margin-bottom: 40px;
  }
}
</style>
